const { createAction } = require('../helpers')
const {
  // For Admin Panel
  GET_FILE_ADMIN,
  GET_FILE_ADMIN_SUCCESS,
  GET_FILE_ADMIN_ERROR,
  GET_FILE_ADMIN_RESET,

  // For Admin Panel - Getting file and pushing into array
  GET_FILE_AND_APPEND_ADMIN,
  GET_FILE_AND_APPEND_ADMIN_SUCCESS,
  GET_FILE_AND_APPEND_ADMIN_ERROR,
  GET_FILE_AND_APPEND_ADMIN_RESET,

  // For Users - Getting file and pushing into array
  GET_FILE_AND_APPEND_USER,
  GET_FILE_AND_APPEND_USER_SUCCESS,
  GET_FILE_AND_APPEND_USER_ERROR,
  GET_FILE_AND_APPEND_USER_RESET,

  // For Admin Panel
  GET_FILES_URL_ADMIN,
  GET_FILES_URL_ADMIN_SUCCESS,
  GET_FILES_URL_ADMIN_ERROR,
  GET_FILES_URL_ADMIN_RESET,
  // For Admin Panel
  UPLOAD_FILES_ADMIN,
  UPLOAD_FILES_ADMIN_SUCCESS,
  UPLOAD_FILES_ADMIN_ERROR,
  UPLOAD_FILES_ADMIN_RESET,

  GET_FILE,
  GET_FILE_SUCCESS,
  GET_FILE_ERROR,
  GET_FILE_RESET,
  // Use-case -> when needs to get file on multiple places in same component
  GET_FILE_TWO,
  GET_FILE_TWO_SUCCESS,
  GET_FILE_TWO_ERROR,
  GET_FILE_TWO_RESET,

  GET_MULTIPLE_FILE,
  GET_MULTIPLE_FILE_SUCCESS,
  GET_MULTIPLE_FILE_ERROR,
  GET_MULTIPLE_FILE_RESET,

  GET_FILES_URL,
  GET_FILES_URL_SUCCESS,
  GET_FILES_URL_ERROR,
  GET_FILES_URL_RESET,
  UPLOAD_FILES,
  UPLOAD_FILES_SUCCESS,
  UPLOAD_FILES_ERROR,
  UPLOAD_FILES_RESET,
  GET_REFERRAL_FILE,
  GET_REFERRAL_FILE_SUCCESS,
  GET_REFERRAL_FILE_ERROR,
  GET_REFERRAL_FILE_RESET,
  GET_MC_FILE,
  GET_MC_FILE_SUCCESS,
  GET_MC_FILE_ERROR,
  GET_MC_FILE_RESET,
  GET_PRESCRIPTION_FILE,
  GET_PRESCRIPTION_FILE_SUCCESS,
  GET_PRESCRIPTION_FILE_ERROR,
  GET_PRESCRIPTION_FILE_RESET,
} = require('./constants')

// For Admin Panel
const getFileAdmin = id => createAction(GET_FILE_ADMIN, { id })
const getFileAdminSuccess = data => createAction(GET_FILE_ADMIN_SUCCESS, { data })
const getFileAdminError = error => createAction(GET_FILE_ADMIN_ERROR, { error })
const getFileAdminReset = () => createAction(GET_FILE_ADMIN_RESET)

// For Admin Panel - Getting file and pushing into array
const getFileAndAppendAdmin = id => createAction(GET_FILE_AND_APPEND_ADMIN, { id })
const getFileAndAppendAdminSuccess = data => createAction(GET_FILE_AND_APPEND_ADMIN_SUCCESS, { data })
const getFileAndAppendAdminError = error => createAction(GET_FILE_AND_APPEND_ADMIN_ERROR, { error })
const getFileAndAppendAdminReset = () => createAction(GET_FILE_AND_APPEND_ADMIN_RESET)

// For Users - Getting file and pushing into array
const getFileAndAppendUser = id => createAction(GET_FILE_AND_APPEND_USER, { id })
const getFileAndAppendUserSuccess = data => createAction(GET_FILE_AND_APPEND_USER_SUCCESS, { data })
const getFileAndAppendUserError = error => createAction(GET_FILE_AND_APPEND_USER_ERROR, { error })
const getFileAndAppendUserReset = () => createAction(GET_FILE_AND_APPEND_USER_RESET)

// For Admin Panel
// eslint-disable-next-line max-len
const uploadFilesAdmin = ({ data, resUrl, dataType }) => createAction(UPLOAD_FILES_ADMIN, { data, resUrl, dataType })
const uploadFilesAdminSuccess = data => createAction(UPLOAD_FILES_ADMIN_SUCCESS, { data })
const uploadFilesAdminError = error => createAction(UPLOAD_FILES_ADMIN_ERROR, { error })
const uploadFilesAdminReset = () => createAction(UPLOAD_FILES_ADMIN_RESET)

// For Admin Panel
const getUploadFilesUrlAdmin = data => createAction(GET_FILES_URL_ADMIN, { data })
const getUploadFilesUrlAdminSuccess = data => createAction(GET_FILES_URL_ADMIN_SUCCESS, { data })
const getUploadFilesUrlAdminError = error => createAction(GET_FILES_URL_ADMIN_ERROR, { error })
const getUploadFilesUrlAdminReset = () => createAction(GET_FILES_URL_ADMIN_RESET)

const getFile = id => createAction(GET_FILE, { id })
const getFileSuccess = data => createAction(GET_FILE_SUCCESS, { data })
const getFileError = error => createAction(GET_FILE_ERROR, { error })
const getFileReset = () => createAction(GET_FILE_RESET)

// Use-case -> when needs to get file on multiple places in same component
const getFileTwo = id => createAction(GET_FILE_TWO, { id })
const getFileTwoSuccess = data => createAction(GET_FILE_TWO_SUCCESS, { data })
const getFileTwoError = error => createAction(GET_FILE_TWO_ERROR, { error })
const getFileTwoReset = () => createAction(GET_FILE_TWO_RESET)

const getMultipleFile = idsArray => createAction(GET_MULTIPLE_FILE, { idsArray })
const getMultipleFileSuccess = data => createAction(GET_MULTIPLE_FILE_SUCCESS, { data })
const getMultipleFileError = error => createAction(GET_MULTIPLE_FILE_ERROR, { error })
const getMultipleFileReset = () => createAction(GET_MULTIPLE_FILE_RESET)

// eslint-disable-next-line max-len
const uploadFiles = ({ data, resUrl, dataType }) => createAction(UPLOAD_FILES, { data, resUrl, dataType })
const uploadFilesSuccess = data => createAction(UPLOAD_FILES_SUCCESS, { data })
const uploadFilesError = error => createAction(UPLOAD_FILES_ERROR, { error })
const uploadFilesReset = () => createAction(UPLOAD_FILES_RESET)

const getUploadFilesUrl = data => createAction(GET_FILES_URL, { data })
const getUploadFilesUrlSuccess = data => createAction(GET_FILES_URL_SUCCESS, { data })
const getUploadFilesUrlError = error => createAction(GET_FILES_URL_ERROR, { error })
const getUploadFilesUrlReset = () => createAction(GET_FILES_URL_RESET)

const getMCFile = id => createAction(GET_MC_FILE, { id })
const getMCFileSuccess = data => createAction(GET_MC_FILE_SUCCESS, { data })
const getMCFileError = error => createAction(GET_MC_FILE_ERROR, { error })
const getMCFileReset = () => createAction(GET_MC_FILE_RESET)

const getReferralFile = id => createAction(GET_REFERRAL_FILE, { id })
const getReferralFileSuccess = data => createAction(GET_REFERRAL_FILE_SUCCESS, { data })
const getReferralFileError = error => createAction(GET_REFERRAL_FILE_ERROR, { error })
const getReferralFileReset = () => createAction(GET_REFERRAL_FILE_RESET)

const getPrescriptionFile = id => createAction(GET_PRESCRIPTION_FILE, { id })
const getPrescriptionFileSuccess = data => createAction(GET_PRESCRIPTION_FILE_SUCCESS, { data })
const getPrescriptionFileError = error => createAction(GET_PRESCRIPTION_FILE_ERROR, { error })
const getPrescriptionFileReset = () => createAction(GET_PRESCRIPTION_FILE_RESET)

module.exports = {
  // For Admin Panel
  getFileAdmin,
  getFileAdminSuccess,
  getFileAdminError,
  getFileAdminReset,

  // For Admin Panel - Getting file and pushing into array
  getFileAndAppendAdmin,
  getFileAndAppendAdminSuccess,
  getFileAndAppendAdminError,
  getFileAndAppendAdminReset,

  // For Users - Getting file and pushing into array
  getFileAndAppendUser,
  getFileAndAppendUserSuccess,
  getFileAndAppendUserError,
  getFileAndAppendUserReset,

  // For Admin Panel
  uploadFilesAdmin,
  uploadFilesAdminSuccess,
  uploadFilesAdminError,
  uploadFilesAdminReset,
  // For Admin Panel
  getUploadFilesUrlAdmin,
  getUploadFilesUrlAdminSuccess,
  getUploadFilesUrlAdminError,
  getUploadFilesUrlAdminReset,

  getFile,
  getFileSuccess,
  getFileError,
  getFileReset,

  getFileTwo,
  getFileTwoSuccess,
  getFileTwoError,
  getFileTwoReset,

  getMultipleFile,
  getMultipleFileSuccess,
  getMultipleFileError,
  getMultipleFileReset,

  uploadFiles,
  uploadFilesSuccess,
  uploadFilesError,
  uploadFilesReset,
  getUploadFilesUrl,
  getUploadFilesUrlSuccess,
  getUploadFilesUrlError,
  getUploadFilesUrlReset,

  getMCFile,
  getMCFileSuccess,
  getMCFileError,
  getMCFileReset,
  getReferralFile,
  getReferralFileSuccess,
  getReferralFileError,
  getReferralFileReset,
  getPrescriptionFile,
  getPrescriptionFileSuccess,
  getPrescriptionFileError,
  getPrescriptionFileReset,
}
